<template>
  <div class="content_main">
    <div class="bgone" id="bgone">
      <div class="centerOne">
        <div class="head">
          <div class="firmlogo">
            <div class="firmlogoright">
              <img src="../../assets/img/logo1.svg" alt="" />
            </div>

          </div>
          <div class="topright">
            <div class="selectleft" id="router">
              <a @click="back" href="javascript:void(0)"><span>Home</span></a>
            </div>
            <div @click="contact_us" class="selectright">
              <div><span>Contact Us Now</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bgtwo product_detail_page">
      <div class="product_basic">
        <div class="pb_left">
          <ul>
            <li v-for="(img,img_i) in this.detail.image" :key="img_i" @click="changeImg(img_i)">
              <img :src="img" alt="" class="img_box_on" v-if="img_i == img_index">
              <img :src="img" alt="" class="img_box" v-else>
            </li>
          </ul>
          <img :src="this.detail.image[this.img_index]" >
        </div>
        <div class="pb_right right-content">
            <div class="s-title">{{ this.detail.title }}</div>
            <div class="s-price">${{ this.detail.price }}</div>

            <div class="s-size">
              <h1>SIZE:</h1>
              <ul>
                <li v-for="ite in this.detail.sizes" :key="ite.id">
                  {{ ite.content }}
                </li>
              </ul>
            </div>
          <div class="s-size">
            <h1>SKU: <span style="color: #6e6e6e">{{ this.detail.sku }}</span></h1>
          </div>
          <div class="s-size">
            <h1>Production Time: <span style="color: #6e6e6e">{{ this.detail.proces_time }}</span></h1>
          </div>
          <div class="s-size">
            <h1>Shipping Time: <span style="color: #6e6e6e">{{ this.detail.shipping_time }}</span></h1>
          </div>
          <div class="s-content">
            <ul>
              <li v-for="item in this.detail.descriptions" :key="item.id">
                {{ item.content }}
              </li>
            </ul>
          </div>
            <div class="s-color" style="display: none">
              <h1>COLOR:</h1>
              <ul>
                <li
                    v-for="its in detail.colors"
                    :key="its.id"
                    :style="{ 'background-color': its.content }"
                ></li>
              </ul>
            </div>
        </div>
      </div>
      <div class="product_detail" >

        <div v-html="this.detail.content"></div>
      </div>
    </div>


    <div class="bgnine">
      <div class="centeNine">
        <div class="foot">
          <div class="footOne">
            <img src="../../assets/img/logo1.svg" alt="" />
            <div class="webfba">
              Webfba –
              We are the All-In-One Dropshipping agent who helps you source and ship anything you need, such as general cargo, liquid, sensitive cargo, what more, we also offer POD service, One-piece also can be customized.
            </div>
          </div>
          <div class="footTwo">
            <div class="footTwoTitle">What we offer</div>
            <div class="footTwoContent">
              <ul>
                <li class="about-us" @click="rot('services',3)">Services</li>
                <li @click="rot('services',4)">POD</li>
                <li @click="product">Product</li>
                <li @click="rot('services',6)">Price</li>
                <li  @click="rot('services',6)">Delivery</li>
                <li  @click="rot('services',6)">Time</li>
                <li  @click="rot('services',8)">Processing</li>
              </ul>
            </div>
          </div>
          <div class="footThree">
            <div class="footThreeTitle">Our Company</div>
            <div class="footThreeContent">
              <ul>
                <li @click="abous">About Us</li>
                <li  @click="rot('services',6)">Why Us？</li>
                <el-button
                    class="contact"
                    type="text"
                    @click="contact_us"
                ><li class="contact_us">Contact Us</li></el-button
                >
              </ul>
            </div>
          </div>
          <div class="footFour">
            <!-- <div class="footFourTitle">Need help?</div>
            <div class="footFourContent">
              <ul>
                <el-button
                  class="contact"
                  type="text"
                  @click="centerDialogVisible = true"
                  ><li class="contact_us">Contact Us</li></el-button
                >

                <li>Help Center</li>
                <li>FAQs</li>
              </ul>
            </div> -->
            <!-- 点击底部contact us弹窗 邮箱链接-->
            <el-dialog
                title="Contact US"
                :visible.sync="centerDialogVisible"
                width="40%"
                center
            >
              <a
                  href="https://mail.google.com/mail/u/0/?fs=1&tf=cm&source=mailto&to=support@webfba.com"
                  style="float: left"
              ><div
                  style="
                    float: left;
                    display: inline;
                    font-size: 2.5rem;
                    line-height: 4rem;
                  "
              >
                click:
              </div>
                <img
                    src="../../assets/img/logo_gmail.png"
                    alt=""
                    style="width: 10rem; height: 4rem; float: right"
                /></a>
              <span slot="footer" class="dialog-footer">
                <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
                <!-- <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button> -->
              </span>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from '../../assets/js/bus';
export default {
  name: "Product_detail",
  data() {
    return {
        detail:[],
        img_index:0
    };
  },
  created() {
    let id = this.$route.params.id
    var _this = this;
    this.http
        .fetchGet(this.api.pd_detail, {product_id:id})
        .then((res) => {
          _this.detail = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
  },
  methods: {
    changeImg(index){
      this.img_index = index;
    },
    abous() {
      this.$router.push({ path: "/Abous_us" });
    },
    product() {
      this.$router.push({ path: "/products" });
    },
    contact_us() {
      this.$router.push({ path: "/contact_us" });
    },
    rot(event,index){
      this.$router.push({ path: "/" });
      Bus.$emit(event,index);

    },
    back() {
      this.$router.go(-1);
      //  this.$router.push({ path: "./" });返回主页顶部
    },
  },
};
</script>
<style>
body{
  font-family: poppins, Sans-serif!important;
}
.img_box{
  border: 2px solid white;
}
.img_box_on{
  border: 2px solid #ff7300;
}
.product_detail_page .product_detail .product_detail_fulfillment {
  position: relative;
  margin-top: 0;
  margin-bottom: 0; }
@media (max-width: 768px) {
  .product_detail_page .product_detail .product_detail_fulfillment {
    width: 100%; } }

.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container {
  max-width: 1438px;
  width: 100%;
  display: flex;
  margin-right: auto;
  margin-left: auto;
  position: relative; }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content {
  padding: 0;
  display: flex;
  position: relative;
  width: 100%;
  flex-wrap: wrap;
  align-content: flex-start; }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fulfillment_heading {
  margin: 0 0 24px; }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fulfillment_heading h2 {
  color: #252525;
  font-family: poppins, Sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px; }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fulfillment_table {
  margin-bottom: 20px;
  width: 100%;
  position: relative;
  box-shadow: none;
  max-width: 100% !important;
  border-radius: 0;
  width: 100% !important;
  transition: all 0.3s;
  padding: 0 0 5px;
  margin: auto !important;
  background-color: #fff; }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fulfillment_table .table_price {
  border-radius: 0;
  background-color: #fff;
  border: 0 solid #e5e7e9;
  font-size: 14px;
  font-family: poppins, sans-serif;
  overflow-x: auto;
  overflow-y: auto;
  max-height: 600px; }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fulfillment_table .table_price .SGSR-table {
  padding: 0;
  border: 1px solid #cacaca;
  border-collapse: collapse;
  margin: 0;
  overflow: auto;
  text-align: center; }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fulfillment_table .table_price .SGSR-table td {
  min-width: 120px; }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fulfillment_table .table_price .SGSR-table tr {
  border: 0;
  text-align: center; }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fulfillment_table .table_price .SGSR-table tr td:first-child {
  white-space: nowrap; }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fulfillment_table .table_price .SGSR-table tr th {
  background-color: #ffa022;

  /*background-color: #caedd8;*/
  padding: 14px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #252525;
  border: 1px solid #cacaca;
  position: sticky;
  top: 0;
  z-index: 1;
  cursor: pointer; }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fulfillment_table .table_price .SGSR-table tr th:first-child {
  border-top-left-radius: 0; }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fulfillment_table .table_price .SGSR-table tbody tr:first-child > td {
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
  color: #252525;
  padding: 27px 15px; }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fulfillment_table .table_price .SGSR-table tbody tr:nth-child(odd) {
  background-color: #fff; }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fulfillment_table .table_price .SGSR-table tbody tr:nth-child(even) {
  /*background-color: #f3faf6; */
  background-color: #ffc47552;
}

.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fulfillment_table .table_price .SGSR-table tbody tr td {
  border: 1px solid #cacaca;
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  color: #252525;
  padding: 20px;
  cursor: pointer; }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fulfillment_table .table_price .SGSR-table .product_china tr td {
  font-weight: 400 !important; }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fullfillment_note {
  width: 100%;
  position: relative;
  margin-top: 19px; }
@media (max-width: 767px) {
  .product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fullfillment_note {
    margin-bottom: 64px; } }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fullfillment_note .fullfillment_note_content {
  max-width: 1438px;
  width: 100%;
  background-color: #f4f4f4;
  border-style: solid;
  border-width: 1px;
  border-color: #cacaca;
  transition: all 0.3s;
  padding: 18px; }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fullfillment_note .fullfillment_note_content p {
  text-align: center;
  color: #525252;
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  margin: 0; }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fullfillment_note .fullfillment_note_content ul {
  margin-left: 24px;
  padding-left: 0; }
.product_detail_page .product_detail .product_detail_fulfillment .product_detail_fulfillment_container .product_detail_fulfillment_content .fullfillment_note .fullfillment_note_content ul li {
  list-style: disc; }
.wc{
  background-color: red;
  font-size: 29px;
  color: white;
}
</style>
<style lang='stylus' scoped>
@import '~@/assets/css/varibles.styl';

.product_detail{
  width: 60%;
  margin: 20px auto;
  padding-bottom: 30px;
}
.product_basic{
  width: 60%;
  margin: 20px auto;
  display: flex;
  .pb_left{
    width:40%;
    display:flex;
    ul{
      width: 20%;
      list-style: none;
    }
    li{
      width: 90%;
      padding:10%;
    }
    img{
      width: 80%;
      height: auto;
      object-fit: contain;
    }
  }
  .pb_right{
    width: 50%;
    font-size: 23px;
    margin-left: 10%;
  }
}


.content_main {
  width: 100%;
  height: 100%;
  font-size: 62.5%;
  min-width: 127rem;

.bgone {
  width: 100%;
  height: 10rem;
  position: fixed;
  top: 0px;
  z-index: 9999;
// backdrop-filter: saturate(180%) blur(6px);
  background-color: rgba(7, 17, 27, 0.5);
// filter: opacity(.3);
  background-color: var(--header-background);
  background-color: #FFFFFF;
  box-shadow: 3rem 0px 4rem #EEE;

// background-image: linear-gradient(#ff7300, #FFFF);
.centerOne {
  width: 120rem;
  margin: 0 auto;

// background-color: greenyellow;
.head {
.firmlogo {
  float: left;
  width: 30.2rem;
  height: 8.1rem;
  margin-top: 1rem;

.firmlogoright {
  float: left;
  width: 26.1rem;
  height: 8.1rem;
  margin-left: -4rem;

img {
  width: 100%;
  height: 100%;
}
}
}

.topright {
  float: right;
  margin-top: 3.1rem;

.selectleft {
  width: 6 0rem;
  float: left;

span {
  display: inline-block;
  font-size: 1.6rem;
  color: #333333;
  margin-left: 4rem;
  font-weight: bold;
  line-height: 4rem;
}

// .onespan {
   // margin-left: 0;
   // }
span:hover {
  color: #FF7300;
}
}

.selectright {
  float: right;
// margin-top:0.5rem;
  background-color: #FF7300;
  border-radius: 0.2rem;
  margin-left: 4rem;
  width: 14rem;
  height: 4rem;
  font-weight: 10rem;

div {
  text-decoration: none;

span {
  display: block;
  color: #FFFFFF;
  font-size: 1.6rem;
  text-align: center;
  font-weight: bold;
  line-height: 4rem;
}
}

span:hover {
  color: #333333;
}
}
}
}
}
}

.bgtwo {
  margin-top: 14rem;

.centertwo {
  width: 90rem;
  margin: 0 auto;

.bgtwo_title {
  font-size: 30px;
  font-weight: 900;
  text-align: center;
  margin-bottom: 10px;
}

.abous_us {
p {
  font-size: 20px;
  line-height: 40px;
  color: #888;
}

.top-line {
  margin-top: 4rem;

.line {
  border: 2px red solid;
  width: 3.5rem;
}

.abous_title {
  font-size: 21px;
  font-weight: bold;
  color: black;
}
}
}
}
}

.bgnine {
  float: left;
  width: 100%;
  height: 35rem;
  background-color: #18252D;
  margin-top: 9.4rem;

.centeNine {
  width: 120rem;
  margin: 0 auto;

.foot {
.footOne {
  width: 40rem;
// height: 5.2rem;
  float: left;
  margin-top: 6rem;

img {
  width: 30%;
}

.webfba {
  color: #FFFFFF;
  font-size: 1.4rem;
  line-height: 3rem;
  font-weight: bold;
  display: inline-block;
}
}

.footTwo {
  widows: 100%;
  width: 13rem;
  float: left;
  margin-top: 6.7rem;
  margin-left: 20rem;

.footTwoTitle {
  font-size: 1.8rem;
  color: #FF7300;
  font-weight: bold;
  float: left;
}

.footTwoContent {
ul {
  margin: 0;
  padding: 0;

li {
  widows: 100%;
  list-style: none;
  font-size: 1.4rem;
  color: #FFFFFF;
  line-height: 3rem;
  font-weight: bold;
// display: inline-block;

// a {
   //   color: #FFFFFF;
   // }

// a:hover {
   //   color: #FF7300;
   // }
}
li:hover{
  color: #FF7300;
  cursor:pointer;
}
}
}
}

.footThree {
  width: 20rem;
  float: left;
  margin-top: 6.7rem;
  margin-left: 25rem;

.footThreeTitle {
  font-size: 1.8rem;
  color: #FF7300;
  font-weight: bold;
  float: left;
  width: 100%;
}

.footThreeContent {
ul {
  margin: 0;
  padding: 0;

li {
  width: 100%;
  list-style: none;
  font-size: 1.4rem;
  color: #FFFFFF;
  line-height: 3rem;
  font-weight: bold;
  display: inline-block;
}
li:hover{
  color: #FF7300;
  cursor:pointer;
}
.contact{
  padding:0;
}
}
}
}

.footFour {
  width: 10rem;
  float: right;
  margin-top: 6.7rem;

.footFourTitle {
  font-size: 1.8rem;
  color: #FF7300;
  font-weight: bold;
  float: left;
  widows: 100%;
}

.footFourContent {
ul {
  margin: 0;
  padding: 0;

li {
  widows: 100%;
  list-style: none;
  font-size: 1.4rem;
  color: #FFFFFF;
  line-height: 3rem;
  font-weight: bold;
  display: inline-block;
}

.contact {
  padding: 0;
}

.contact_us:hover {
  color: #FF7300;
}
}
}
}
}
}
}
}

/* right css*/
.right-content {
  float: right;
  width: 65%;

  .s-title {
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 5px;
  }
}

.s-price {
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 1em;
  color: #e61454;
}

.s-content {
// height: 20rem;
// overflow: hidden;
  ul {
    margin-left: 2rem;
    margin-top: 5px;
    line-height: 1em;
    li {
      font-size: .6em;
      list-style-type: disc;
    }
  }
}

.s-size {
  margin-top: 1rem;

h1 {
  display: inline-block;
  font-weight: 600;
  font-size: 14px;
}

ul {
  display: inline-block;

li {
  font-size: 14px;
  display: inline-block;
  padding: 0 11px;
  border: 1px solid #cacaca;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 3px;
  margin-left: 0.5rem;
  font-weight: bold;
}
}
}

.s-color {
  margin-top: 1rem;

h1 {
  display: inline-block;
  font-weight: 600;
  font-size: 14px;
}

ul {
  display: inline-block;

li {
  display: inline-block;
  width: 2.2rem;
  height: 2.2rem;
  background-color: #282828;
  border-radius: 2px;
  margin-left: 0.3rem;
}
}
}


</style>
